import { SchedulerDashboard } from './SchedulerDashboard'

export default SchedulerDashboard
